import { Button, Stack, Text } from '@mantine/core'
import MainDrawer from 'app/views/components/Drawer/MainDrawer'
import MainTable from 'app/views/components/Table/MainTable'
import { SetStateAction, useEffect, useState } from 'react'
import { EntityParams } from 'app/models/entity-params'
import { WireInstructionParams } from 'app/models/wire-instruction-params'
import { MRT_RowSelectionState } from 'mantine-react-table'
import { columnDefsWireInstructionDrawer } from './wire-instruction-columnDefs';
import { useDispatch } from 'react-redux';
import { ErrorNotification, SuccessNotification } from 'app/views/components/notifications/notification'
import { saveWireInstructionChange } from 'app/state/ducks/sub-trades/thunks'
import { RefinedSubTrade } from 'app/models/traded-facilities-params'

interface Props {
    open: boolean
    setOpen: React.Dispatch<SetStateAction<boolean>>
    entity: EntityParams | null
    wireInstructions?: WireInstructionParams[]
    refinedSubTrade: RefinedSubTrade
    selectWireInstruction: string
    selectedEntityAction: string

}

export default function WireInstructionDrawer({ open, setOpen, entity, wireInstructions, refinedSubTrade, selectWireInstruction, selectedEntityAction }: Props) {
    const [loader, setLoader] = useState<boolean>(false)
    const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
    const [selectedData, setSelectedData] = useState<WireInstructionParams | null>(null);
    const dispatch = useDispatch();


    useEffect(() => {
        if (!selectWireInstruction) {
            // clear selection if nothing to select
            setRowSelection({});
            return;
        }
        // Early return if wireInstructions is undefined/null
        if (!wireInstructions) {
            setRowSelection({});
            return;
        }

        // build the new selection state
        const newSel: MRT_RowSelectionState = {};
        wireInstructions.forEach((wi) => {
            if (selectWireInstruction === wi.id) {
                newSel[wi.id] = true;
            }
        });
        setRowSelection(newSel);
    }, [selectWireInstruction, wireInstructions]);


    const saveWireInstruction = async () => {
        const data = {
            subTradeId: { id: refinedSubTrade.id, admin: refinedSubTrade.agencyAdmin },
            newWireInstruction: { id: selectedData?.id, admin: selectedData?.public },
            masterTradeId: refinedSubTrade.masterTradeId,
            buyerOrSellerEntity: selectedEntityAction === 'Buyer' ? 'Sell' : 'Buy'
        };
        setLoader(true);
        try {
            const response: any = await dispatch(saveWireInstructionChange(data));
            if (response?.success) {
                SuccessNotification({ title: 'Saved Wire Instruction Change' });
            } else {
                ErrorNotification({
                    title: 'Sub Trade Allocation Failed to Save',
                    message: response.payload ?? 'Check data and try again',
                });
            }
        } catch {
            ErrorNotification({
                title: 'Sub Trade Allocation Failed to Save',
                message: 'Check data and try again',
            });
        } finally {
            setLoader(false);
        }
    };


    return (
        <MainDrawer
            opened={open}
            setOpen={setOpen}
            titleText="Wire Instructions"
            fromSize="60%"
        >
            <Stack spacing="20px !important" justify="space-between" h="100%" >
                <div className='sub-trade-fee-drawer-header-wire-instruction'>
                    <Text className='sub-trade-fee-drawer-header-name-text'>{refinedSubTrade?.systemId}</Text>
                    <Text className='sub-trade-fee-drawer-header-text' >{entity?.entityName}</Text>
                </div>

                <MainTable
                    tableName="Fee calcs"
                    columnDefs={columnDefsWireInstructionDrawer}
                    data={wireInstructions || []}
                    setRow={() => { }}
                    enableMultiRowSelection={false}
                    enableRowSelection={true}
                    tableSelectedRows={rowSelection}
                    setTableSelectedRows={setRowSelection}
                    selectedRows={(selectedData) => {
                        setSelectedData(selectedData[0]);
                    }}
                    headerBackgroundColor="#F0EEEE"
                    enableTopToolbar={false}
                    withPagination={false}
                    csvExportEnabled={false}
                    enableColumnResizing={false}
                    enableColumnOrdering={false}
                    enableSorting={false}
                    enableGrouping={false}
                    minHeight="0px"
                    isLoading={loader}
                    border={true}
                />
                <div className="action-buttons-block">
                    <Button className="cancel-button" onClick={() => setOpen(false)}>Cancel</Button>
                    <Button
                        className="delete-button stratch-delete-button"
                        onClick={saveWireInstruction}
                    >
                        Save
                    </Button>
                </div>
            </Stack>
        </MainDrawer >
    )
}
